var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bj-col bj-col-12" },
    [
      _c("div", { staticClass: "bj-form-title" }, [
        _vm._v(
          " " +
            _vm._s(_vm.$t("ExternalOrders.newAdd.receivingInformation")) +
            " "
        ),
        _vm.isShowEdit
          ? _c(
              "span",
              { staticClass: "link right", on: { click: _vm.openDialog } },
              [_vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Modify")))]
            )
          : _vm._e(),
      ]),
      _vm._l(_vm.displayFields, function (field) {
        return _c("div", { key: field.key, staticClass: "bj-form-item" }, [
          _c("div", { staticClass: "bj-formItemLabel" }, [
            _vm._v(_vm._s(_vm.$t(field.label))),
          ]),
          _c("div", { staticClass: "bj-form-item-value" }, [
            _vm._v(_vm._s(_vm.receiverInfoVO && _vm.receiverInfoVO[field.key])),
          ]),
        ])
      }),
      _c(
        "el-dialog",
        {
          staticClass: "buyer-info-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            width: "870px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "dialog-custom-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("i", {
                staticClass: "el-icon-location-outline",
                staticStyle: {
                  "margin-right": "6px",
                  "font-size": "18px",
                  "vertical-align": "middle",
                  color: "#409EFF",
                },
              }),
              _c("span", { staticStyle: { "vertical-align": "middle" } }, [
                _vm._v(
                  _vm._s(_vm.$t("ExternalOrders.newAdd.chooseShippingAddress"))
                ),
              ]),
            ]
          ),
          _vm.hasAnomaly || _vm.hasInvalidFields
            ? _c(
                "div",
                { staticClass: "anomaly-alert" },
                [
                  _c("i", {
                    staticClass: "el-icon-warning",
                    staticStyle: { color: "#f56c6c", "margin-right": "6px" },
                  }),
                  _vm.hasInvalidFields
                    ? [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "ExternalOrders.newAdd.anomalyDetected3Pre"
                              )
                            ) +
                            " "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "anomaly-maps-link",
                            attrs: {
                              href: "https://www.google.com/maps",
                              target: "_blank",
                            },
                          },
                          [_vm._v("Google Maps")]
                        ),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "ExternalOrders.newAdd.anomalyDetected3Post"
                              )
                            ) +
                            " "
                        ),
                      ]
                    : [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                _vm.hasValidSuggestion
                                  ? "ExternalOrders.newAdd.anomalyDetected"
                                  : "ExternalOrders.newAdd.anomalyDetected2"
                              )
                            ) +
                            " "
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "address-columns" }, [
            _c(
              "div",
              {
                staticClass: "address-card",
                class: { "card-selected": _vm.selectedOption === "original" },
                on: {
                  click: function ($event) {
                    _vm.selectedOption = "original"
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "card-header" },
                  [
                    _c(
                      "el-radio",
                      {
                        staticClass: "card-radio",
                        attrs: { label: "original" },
                        model: {
                          value: _vm.selectedOption,
                          callback: function ($$v) {
                            _vm.selectedOption = $$v
                          },
                          expression: "selectedOption",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("ExternalOrders.newAdd.currentAddress"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "card-section-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("ExternalOrders.newAdd.buyerAndReceivingInfo")
                    )
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "info-list",
                    on: {
                      click: function ($event) {
                        _vm.isEditing && $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "info-row" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.newAdd.DeliveryName")
                            ) + ":"
                          ),
                        ]),
                        !_vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass: "info-value",
                                class: {
                                  "diff-tag": _vm.fieldDiff.receiverName,
                                },
                              },
                              [_vm._v(_vm._s(_vm.editForm.receiverName || "—"))]
                            )
                          : _c("BjInput", {
                              staticClass: "row-input",
                              attrs: {
                                size: "mini",
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t("inputText"),
                              },
                              model: {
                                value: _vm.editForm.receiverName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "receiverName", $$v)
                                },
                                expression: "editForm.receiverName",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "info-row" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.newAdd.DeliveryPhone")
                            ) + ":"
                          ),
                        ]),
                        !_vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass: "info-value",
                                class: { "diff-tag": _vm.fieldDiff.phone },
                              },
                              [_vm._v(_vm._s(_vm.editForm.phone || "—"))]
                            )
                          : _c("BjInput", {
                              staticClass: "row-input",
                              attrs: {
                                size: "mini",
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t("inputText"),
                              },
                              model: {
                                value: _vm.editForm.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "phone", $$v)
                                },
                                expression: "editForm.phone",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "info-row" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.newAdd.DestinationCountry")
                            )
                          ),
                          _vm.fieldValidateStatus.country === false
                            ? _c("i", {
                                staticClass:
                                  "el-icon-warning label-invalid-icon",
                              })
                            : _vm._e(),
                          _vm._v(":"),
                        ]),
                        !_vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass: "info-value",
                                class: { "diff-tag": _vm.fieldDiff.country },
                              },
                              [_vm._v(_vm._s(_vm.editForm.country || "—"))]
                            )
                          : _c("BjSelectLov", {
                              staticClass: "row-input",
                              attrs: {
                                size: "mini",
                                "option-list": _vm.COUNTRY_NAME_AND_TWOCODE,
                                placeholder: _vm.$t("chooseText"),
                              },
                              model: {
                                value: _vm.editForm.country,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "country", $$v)
                                },
                                expression: "editForm.country",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "info-row" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.newAdd.DeliveryState")
                            )
                          ),
                          _vm.fieldValidateStatus.province === false
                            ? _c("i", {
                                staticClass:
                                  "el-icon-warning label-invalid-icon",
                              })
                            : _vm._e(),
                          _vm._v(":"),
                        ]),
                        !_vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass: "info-value",
                                class: { "diff-tag": _vm.fieldDiff.province },
                              },
                              [_vm._v(_vm._s(_vm.editForm.province || "—"))]
                            )
                          : _c("BjInput", {
                              staticClass: "row-input",
                              attrs: {
                                size: "mini",
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t("inputText"),
                              },
                              model: {
                                value: _vm.editForm.province,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "province", $$v)
                                },
                                expression: "editForm.province",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "info-row" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.newAdd.DeliverySuburb")
                            )
                          ),
                          _vm.fieldValidateStatus.district === false
                            ? _c("i", {
                                staticClass:
                                  "el-icon-warning label-invalid-icon",
                              })
                            : _vm._e(),
                          _vm._v(":"),
                        ]),
                        !_vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass: "info-value",
                                class: { "diff-tag": _vm.fieldDiff.district },
                              },
                              [_vm._v(_vm._s(_vm.editForm.district || "—"))]
                            )
                          : _c("BjInput", {
                              staticClass: "row-input",
                              attrs: {
                                size: "mini",
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t("inputText"),
                              },
                              model: {
                                value: _vm.editForm.district,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "district", $$v)
                                },
                                expression: "editForm.district",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "info-row" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.newAdd.DeliveryPostcode")
                            )
                          ),
                          _vm.fieldValidateStatus.zipCode === false
                            ? _c("i", {
                                staticClass:
                                  "el-icon-warning label-invalid-icon",
                              })
                            : _vm._e(),
                          _vm._v(":"),
                        ]),
                        !_vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass: "info-value",
                                class: { "diff-tag": _vm.fieldDiff.zipCode },
                              },
                              [_vm._v(_vm._s(_vm.editForm.zipCode || "—"))]
                            )
                          : _c("BjInput", {
                              staticClass: "row-input",
                              attrs: {
                                size: "mini",
                                maxlength: _vm.MAX_LENGTH.SHORT_NAME,
                                placeholder: _vm.$t("inputText"),
                              },
                              model: {
                                value: _vm.editForm.zipCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editForm, "zipCode", $$v)
                                },
                                expression: "editForm.zipCode",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "info-row" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.newAdd.DeliveryAddress1")
                            )
                          ),
                          _vm.fieldValidateStatus.deliveryAddress1 === false
                            ? _c("i", {
                                staticClass:
                                  "el-icon-warning label-invalid-icon",
                              })
                            : _vm._e(),
                          _vm._v(":"),
                        ]),
                        !_vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass: "info-value",
                                class: {
                                  "diff-tag": _vm.fieldDiff.deliveryAddress1,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.editForm.deliveryAddress1 || "—")
                                ),
                              ]
                            )
                          : _c("BjInput", {
                              staticClass: "row-input",
                              attrs: {
                                size: "mini",
                                type: "textarea",
                                autosize: { minRows: 1, maxRows: 3 },
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t("inputText"),
                              },
                              model: {
                                value: _vm.editForm.deliveryAddress1,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "deliveryAddress1",
                                    $$v
                                  )
                                },
                                expression: "editForm.deliveryAddress1",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "info-row" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.newAdd.DeliveryAddress2")
                            ) + ":"
                          ),
                        ]),
                        !_vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass: "info-value",
                                class: {
                                  "diff-tag": _vm.fieldDiff.deliveryAddress2,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.editForm.deliveryAddress2 || "—")
                                ),
                              ]
                            )
                          : _c("BjInput", {
                              staticClass: "row-input",
                              attrs: {
                                size: "mini",
                                type: "textarea",
                                autosize: { minRows: 1, maxRows: 3 },
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t("inputText"),
                              },
                              model: {
                                value: _vm.editForm.deliveryAddress2,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "deliveryAddress2",
                                    $$v
                                  )
                                },
                                expression: "editForm.deliveryAddress2",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "info-row" },
                      [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.newAdd.emailAddress")
                            ) + ":"
                          ),
                        ]),
                        !_vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass: "info-value",
                                class: {
                                  "diff-tag":
                                    _vm.fieldDiff.deliveryEmailAddress,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.editForm.deliveryEmailAddress || "—"
                                  )
                                ),
                              ]
                            )
                          : _c("BjInput", {
                              staticClass: "row-input",
                              attrs: {
                                size: "mini",
                                maxlength: _vm.MAX_LENGTH.NORMAL_REMARK,
                                placeholder: _vm.$t("inputText"),
                              },
                              model: {
                                value: _vm.editForm.deliveryEmailAddress,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editForm,
                                    "deliveryEmailAddress",
                                    $$v
                                  )
                                },
                                expression: "editForm.deliveryEmailAddress",
                              },
                            }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      disabled: _vm.selectedOption === "original",
                      content: _vm.$t(
                        "ExternalOrders.newAdd.selectCurrentAddressTip"
                      ),
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "edit-address-link" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              disabled: _vm.selectedOption !== "original",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                _vm.isEditing = !_vm.isEditing
                              },
                            },
                          },
                          [
                            _c("i", {
                              class: _vm.isEditing
                                ? "el-icon-check"
                                : "el-icon-edit",
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.isEditing
                                    ? _vm.$t("ExternalOrders.newAdd.doneEdit")
                                    : _vm.$t(
                                        "ExternalOrders.newAdd.editAddress"
                                      )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "address-card",
                class: {
                  "card-selected": _vm.selectedOption === "suggestion",
                  "card-disabled": !_vm.hasValidSuggestion,
                },
                on: {
                  click: function ($event) {
                    _vm.hasValidSuggestion &&
                      (_vm.selectedOption = "suggestion")
                  },
                },
              },
              [
                _c("div", { staticClass: "recommended-badge" }, [
                  _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.RECOMMENDED"))),
                ]),
                _c(
                  "div",
                  { staticClass: "card-header" },
                  [
                    _c(
                      "el-radio",
                      {
                        staticClass: "card-radio",
                        attrs: {
                          label: "suggestion",
                          disabled: !_vm.hasValidSuggestion,
                        },
                        model: {
                          value: _vm.selectedOption,
                          callback: function ($$v) {
                            _vm.selectedOption = $$v
                          },
                          expression: "selectedOption",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("ExternalOrders.newAdd.suggestion"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "card-section-title" }, [
                  _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.verifiedInfo"))),
                ]),
                _c("div", { staticClass: "info-list" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryName")) +
                          ":"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: {
                          "diff-tag suggestion": _vm.fieldDiff.receiverName,
                        },
                      },
                      [_vm._v(_vm._s(_vm.suggestionInfo.receiverName || "—"))]
                    ),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryPhone")) +
                          ":"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: { "diff-tag suggestion": _vm.fieldDiff.phone },
                      },
                      [_vm._v(_vm._s(_vm.suggestionInfo.phone || "—"))]
                    ),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("ExternalOrders.newAdd.DestinationCountry")
                        ) + ":"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: { "diff-tag suggestion": _vm.fieldDiff.country },
                      },
                      [_vm._v(_vm._s(_vm.suggestionInfo.country || "—"))]
                    ),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryState")) +
                          ":"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: {
                          "diff-tag suggestion": _vm.fieldDiff.province,
                        },
                      },
                      [_vm._v(_vm._s(_vm.suggestionInfo.province || "—"))]
                    ),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("ExternalOrders.newAdd.DeliverySuburb")) +
                          ":"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: {
                          "diff-tag suggestion": _vm.fieldDiff.district,
                        },
                      },
                      [_vm._v(_vm._s(_vm.suggestionInfo.district || "—"))]
                    ),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("ExternalOrders.newAdd.DeliveryPostcode")
                        ) + ":"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: { "diff-tag suggestion": _vm.fieldDiff.zipCode },
                      },
                      [_vm._v(_vm._s(_vm.suggestionInfo.zipCode || "—"))]
                    ),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("ExternalOrders.newAdd.DeliveryAddress1")
                        ) + ":"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: {
                          "diff-tag suggestion": _vm.fieldDiff.deliveryAddress1,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.suggestionInfo.deliveryAddress1 || "—")
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("ExternalOrders.newAdd.DeliveryAddress2")
                        ) + ":"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: {
                          "diff-tag suggestion": _vm.fieldDiff.deliveryAddress2,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.suggestionInfo.deliveryAddress2 || "—")
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("ExternalOrders.newAdd.emailAddress")) +
                          ":"
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: {
                          "diff-tag suggestion":
                            _vm.fieldDiff.deliveryEmailAddress,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.suggestionInfo.deliveryEmailAddress || "—")
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      _vm.selectedOption === "suggestion" || _vm.isEditing,
                  },
                  on: { click: _vm.handleUseOriginal },
                },
                [_vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.useOriginal")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled:
                      _vm.selectedOption === "original" ||
                      !_vm.hasValidSuggestion,
                  },
                  on: { click: _vm.handleUseSuggestion },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("ExternalOrders.newAdd.useSuggestion")) + " →"
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }